import { Wallet } from "lucide-react";

export function PatientFinanceiroTab({ patientId: _patientId }: { patientId: string }) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-semibold text-zinc-900">Financeiro</h3>
        <p className="mt-1 text-xs text-zinc-500">
          Saldo, pagamentos, recibos e faturas do paciente.
        </p>
      </div>

      <div className="rounded-xl border border-dashed border-zinc-200 bg-zinc-50/50 p-8 text-center">
        <Wallet className="mx-auto h-10 w-10 text-zinc-300" />
        <p className="mt-3 text-sm font-medium text-zinc-700">Financeiro — em desenvolvimento</p>
        <p className="mt-1 text-xs text-zinc-500">
          Em breve: saldo em aberto destacado, histórico de pagamentos, recibos,
          parcelas do plano, e emissão de nota fiscal.
        </p>
      </div>
    </div>
  );
}
